import { Button, makeStyles, tokens } from '@fluentui/react-components';
import { useAutomationRuleConditions } from './use-conditions';

interface Props {
  isLast?: boolean;
}

export default function FormDividerConditions(props: Props){
	const {conditions, addNewCondition} = useAutomationRuleConditions();

	const classes = useStyles();

	return (
		<>
			<div className={classes.formDivider} />
			{(!conditions.length || props.isLast) && (
				<Button size='small' onClick={() => {addNewCondition();}}>
          Add condition
				</Button>
			)}
		</>
	);
}

const useStyles = makeStyles({
	formDivider: {
		height: '32px',
		width: '1px',
		backgroundColor: tokens.colorNeutralForegroundDisabled,
		marginLeft: '32px'
	}
});